<template>
    <v-container fluid>
        <v-row v-if="isLoading">
            <v-col>
                <loading-spinner></loading-spinner>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <editor-card :value="post.content" @update-content="updateContent">
                    <template v-slot:card-header>
                        <card-header :title="titles.write"></card-header>
                    </template>
                    
                    <template v-slot:header>
                        <v-row align="center">
                            <v-col cols="1">
                                <label class="d-flex text-body-1 align-self-center">{{ titles.editor }}</label>
                            </v-col>
                            <v-col cols="11">
                                <v-text-field v-model="post.title" dense></v-text-field>
                            </v-col>
                        </v-row>
                    </template>

                    <!-- 버튼 영역 -->
                    <template v-slot:bottom-buttons>
                        <div class="d-flex justify-space-between mt-10 mb-5">
                            <custom-button 
                            @click="goBack" 
                            color="black" 
                            :label="buttons.close" 
                            size="lg" 
                            gradient
                            rounded
                            ></custom-button>
                                
                            <custom-button 
                            @click="handleSubmit" 
                            color="primary" 
                            :label="buttons.submit" 
                            size="lg" 
                            gradient
                            rounded
                            ></custom-button>
                        </div>
                    </template>
                </editor-card>
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
import EditorCard from "@/components/common/Cards/EditorCard.vue";
import { membernewsLabel } from "@/views/BoardView/label";
import { success, savePopup } from "@/views/BoardView/popups";
import { boardApi } from "@/api/api";
import CardHeader from '@/components/cards/CardHeader.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

export default {
    components: {
        EditorCard,
        CardHeader,
        LoadingSpinner,
        CustomButton,
    },
    props: {
        idx: {
            type: [String, Number],
            required: false,
        }
    },
    data() {
        return {
            titles: membernewsLabel.titles,
            buttons: membernewsLabel.buttons,
            isLoading: false,
            post: {
                board_idx: 2,
                title: null,
                content: null,
            }
        }
    },
    methods: {
        toMembernewList() {
            this.$router.push("/posts/membernews");
        },
        goBack() {
            this.$router.go(-1);
        },
        async handleSubmit() {
            const isConfirmed = await savePopup();
            if (!isConfirmed) return;
            
            const isCreate = this.idx == null;
            let isSuccess;
            
            if (isCreate) {
                isSuccess = await this.createPost(this.post);
            } else {
                isSuccess = await this.updatePost(this.post);
            }
            
            if (isSuccess) {
                await success();
                await this.toMembernewList();
            }
        },
        async createPost(post) {
            try {
                this.isLoading = true;
                const response = await boardApi.createPost(post);
                return response && response.status === 201;
            } catch {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        async updatePost(post) {
            try {
                this.isLoading = true;
                const response = await boardApi.updatePost(post);
                return response && response.status === 200;
            } catch {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        async fetchPost() {
            this.isLoading = true;
            try {
                const response = await boardApi.getPost({ idx: this.idx });
                if (response && response.status === 200) {
                    this.post = response.data.response;
                    return true;
                }
                return false;
            } catch {
                alert("요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.");
                this.goBack();
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        updateContent(newValue) {
            this.post.content = newValue;
        },
    },
    mounted() {
        if (this.idx != null) {
            this.fetchPost();
        }
    }
};
</script>

<style scoped>
</style>